import React, { Component } from 'react';

class CardAccordion extends Component {
	constructor(props) {
		super(props);
	
		this.state = {
			open: false
		}
	}

	toggleAccordion = () => {
		let { open } = this.state
		this.setState({ open: !open });
	}

    render() {
		const { color, header, content, noBorder, page } = this.props
		const { open } = this.state
		const classes = [
			'card',
			'card--accordion',
			(noBorder) ? `card--no-border` : '',
			(color) ? `card--${color}` : '',
			(page) ? `card--${page}` : ''
		];
		const arrowClasses = [
			'card__arrow',
			(open) ? 'card__arrow--opened' : ''
		];
		return (
			<div className={classes.join(' ')}>
				<div className="card__content card__content--full">
					<div onClick={() => this.toggleAccordion()}>
						<div className={arrowClasses.join(' ')}>
							<svg xmlns="http://www.w3.org/2000/svg" width="26.599" height="14.977"><path d="M14.206 14.106L25.617 2.687A1.282 1.282 0 0023.806.872L13.3 11.387 2.792.877a1.282 1.282 0 00-1.81 1.81l11.41 11.42a1.293 1.293 0 001.814-.001z" fill="#feb000" stroke="#feb000"/></svg>
						</div>
						{header}
					</div>
					{ open && <div>{content}</div> }
				</div>
			</div>
		);
    }
}

class CardAccordionHeader extends Component {
    render() {
		const { border, children } = this.props
		const classes = [
			'card__content__header',
			(!border) ? `card__content__header--no-border` : ''
		];
		return (
			<div className={classes.join(' ')}>
				{children}
			</div>
		);
    }
}

class CardAccordionBody extends Component {
    render() {
		const { children } = this.props
		const classes = [
			'card__content__body'
		];
		return (
			<div className={classes.join(' ')}>
				{children}
			</div>
		);
    }
}

export { CardAccordion, CardAccordionHeader, CardAccordionBody };